import React from "react";

import './DTreeCreatedGrowl.css';

export default function DTreeCreatedGrowl({ treeUrl }){
	return (
		<div className="dtree-created-growl">
			<div>The AI agent created a new decision tree</div>
			<div>
				<a href={treeUrl} target="_blank" rel="noreferrer">View Decision Tree</a>
			</div>
		</div>
	);
}
